import { useRef, useState,useEffect } from 'react';
import { motion, useInView } from 'framer-motion';
import { ShieldCheck, Package, Star, Truck } from 'lucide-react';
import { getShippingFee } from '../../services/userService';
const InfoBanner = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });
  const [flipped, setFlipped] = useState(null);
  const [shippingInfo, setShippingInfo] = useState({
    orderMinPay: 0,
  });
  useEffect(() => {
    const fetchShippingInfo = async () => {
      const data = await getShippingFee();
      setShippingInfo(data);
    };

    fetchShippingInfo();
  }, []);
  const bannerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  const infoBoxes = [
    {
      id: 1,
      title: "Güvenli Alışveriş",
      description: "SSL sertifikalı güvenli ödeme sistemleriyle hizmetinizdeyiz",
      bgColor: "bg-gradient-to-br from-[#bb3570] to-[#e3b1d2]",
      icon: <ShieldCheck className="w-12 h-12" />,
    },
    {
      id: 2,
      title: "Tuhafiye Ürünleri",
      description: "Geniş ürün yelpazesiyle hizmetinizdeyiz",
      bgColor: "bg-gradient-to-br from-[#e3b1d2] to-[#fbebe3]",
      icon: <Package className="w-12 h-12" />,
    },
    {
      id: 3,
      title: "Hac Malzemeleri",
      description: "Hac ibadetiniz için tüm ihtiyaçlarınız burada",
      bgColor: "bg-gradient-to-br from-[#fbebe3] to-[#e3b1d2]",
      icon: <Star className="w-12 h-12" />,
    },
    {
      id: 4,
      title: "Ücretsiz Kargo",
      description: `${shippingInfo.orderMinPay.toLocaleString()} TL ve üzeri alışverişlerde kargo bizden`,
      bgColor: "bg-gradient-to-br from-[#e3b1d2] to-[#bb3570]",
      icon: <Truck className="w-12 h-12" />,
    }
  ];
  

  return (
    <section className="py-16 bg-secondary-light">
      <div className="container-custom" ref={ref}>
        <motion.h2 
          className="section-title text-center mb-12"
          initial={{ opacity: 0, y: -20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
        >
          Neden Biz?
        </motion.h2>

        <motion.div 
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6"
          variants={bannerVariants}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
        >
          {infoBoxes.map((box) => (
            <motion.div 
              key={box.id}
              variants={itemVariants}
              className="h-64 cursor-pointer perspective-1000"
              onHoverStart={() => setFlipped(flipped === box.id ? null : box.id)}
              onHoverEnd={() => setFlipped(flipped === box.id ? null : box.id)}
              onClick={() => setFlipped(flipped === box.id ? null : box.id)}
            >
              <div 
                className={`relative w-full h-full transition-transform duration-500 transform-style-preserve-3d ${
                  flipped === box.id ? 'rotate-y-180' : ''
                }`}
              >
                {/* Front side */}
                <div 
                  className={`absolute w-full h-full ${box.bgColor} rounded-lg shadow-soft p-6 text-white backface-hidden flex flex-col items-center justify-center text-center`}
                >
                  <div className="mb-4">{box.icon}</div>
                  <h3 className="text-xl font-bold">{box.title}</h3>
                </div>

                {/* Back side */}
                <div 
                  className={`absolute w-full h-full ${box.bgColor} rounded-lg shadow-soft p-6 text-muted backface-hidden rotate-y-180 flex flex-col items-center justify-center text-center`}
                >
                  <p className="text-lg">{box.description}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default InfoBanner;